import type { NavigationGuard } from "vue-router";
import { RouteNames } from "@shared/types/localTypes/router.ts";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";
import { appService } from "@shared/services/app.ts";
import logger from "@shared/utils/logger.ts";

export const impersonateLogin: NavigationGuard = async (to) => {
  const loginHint = to.query.login_hint?.toString();
  const impersonateSecret = to.query.a?.toString();

  if (!loginHint || !impersonateSecret) {
    logger.error("Impersonate login is missing mandatory parameters");
    return { name: RouteNames.Login };
  }

  const keycloakStore = useKeycloakStore();
  await keycloakStore.initializeKeycloak();

  const keycloak = keycloakStore.keycloak;
  if (!keycloak) {
    logger.error("Impersonate login could not reach Keycloak");
    return { name: RouteNames.Login };
  }

  // Keycloak has already destroyed the previous session by the time the browser gets here, so drop
  // its leftover client state. Must happen before createLoginUrl, which stores the PKCE verifier
  // in localStorage.
  await appService.clearSessionCache();

  const loginUrl = await keycloak.createLoginUrl({
    loginHint,
    redirectUri: `${window.location.origin}/login`,
  });

  // "a" carries the impersonate credential and is read by the Keycloak login theme from
  // window.location.search. keycloak-js has no option for extra authorize params, so it is
  // appended here - encoded, because vue-router already decoded it and raw "+" would be read
  // back as a space.
  window.location.assign(
    `${loginUrl}&a=${encodeURIComponent(impersonateSecret)}`,
  );

  return false;
};
